// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { OperationsSubscriptions } from '../../../../types/server/modules/operations/subscriptions';

export type * from '../../../../types/server/modules/operations/subscriptions';

export const createSubscriptions = ( requests: Requests ): OperationsSubscriptions => ({
  OperationsRuns: ( params, onChange ) => {
          return requests.subscribe( `/operations/runs/:id?`, params, 'OperationsRuns', onChange );
          }
});
